import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import Contentful from '../contentful';
import ResponsiveImage from '../layout/images/responsive';
import MomentDate from '../date/date';
import styles from './listing.scss';

class PostsListing extends Component {
  render() {
    const { id, query, moreUrl, moreLabel } = this.props;

    return (
      <Contentful key={id} loadingIndicator={true} query={{ content_type: 'post', include: 5, ...query, order: '-fields.publishedAt' }}>
        {({ items, total }) => {

          if (total === 0 || items.length === 0) {
            return null;
          }

          const posts = items.map((post) => {
            const postUrl = '/p/' + post.fields.slug;

            return (
              <article key={post.sys.id} className={styles.post}>
                <div className={styles.cover}>
                  <NavLink to={postUrl}>
                    <ResponsiveImage image={post.fields.sharingImage} ratio={65} showCaption={false}/>
                  </NavLink>
                </div>
                <div className={styles.body}>
                  <div className={styles.publishedAt}>
                    <MomentDate date={post.fields.publishedAt}/>
                  </div>
                  <h2 className={styles.title}>
                    <NavLink to={postUrl}>
                      {post.fields.title}
                    </NavLink>
                  </h2>
                  <div className={styles.teaser}>
                    {post.fields.teaser}
                    <div className={styles.readOn}>
                      <NavLink to={postUrl}>Weiterlesen »</NavLink>
                    </div>
                  </div>
                </div>
              </article>
            );
          });

          console.log(moreUrl, moreLabel);

          return (
            <section className={styles.posts}>
              {posts}
              {( (moreUrl && moreLabel)&&
                <div className={styles.moreLink}>
                  <NavLink to={moreUrl}>{moreLabel}</NavLink>
                </div>
              )}
            </section>
          )
        }}
      </Contentful>
    );
  }
}

PostsListing.propTypes = {
  query: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  moreUrl: PropTypes.string,
  moreLabel: PropTypes.string
}

export default PostsListing;



// WEBPACK FOOTER //
// ./src/components/posts/listing.jsx